import CatalogPage from '@/pages/catalog/CatalogPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/$')({
  component: CatalogPage,
})
